module.exports = __webpack_public_path__ + "fonts/Sahel-Bold.5c4e28a.ttf";